import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { RegistryWithVendorDto } from '../dtos/registry/models';

@Injectable({
  providedIn: 'root',
})
export class RegistryService {
  private restService = inject(RestService);
  apiName = 'Orchestrator';
  

  getById = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, RegistryWithVendorDto>({
      method: 'GET',
      url: `/api/Planning/Registry/${id}`,
    },
    { apiName: this.apiName,...config });
}